import React from 'react'
import { Flex, List } from 'antd-mobile'
import { formatMoney } from '../../components/common/utils'

import styles from '../../pages/PriceList/PriceList.module.css'

const OrderItem = ({ item, orderPrice = '' }) => {
  return (
    <List.Item align="bottom" thumb={item.picUrl} wrap>
      {item.title}
      <List.Item.Brief>
        <Flex justify="between">
          <div>
            <span className={styles.crossPrice}>{formatMoney(item.price, item.currencyType)}</span>
            <span className={styles.price}>{orderPrice ? formatMoney(orderPrice, item.currencyType) : ''}</span>
            {item.weight != null && <span className={styles.weightText}>{item.weight}kg</span>}
          </div>
          <span>{'x' + item.number}</span>
        </Flex>
      </List.Item.Brief>
    </List.Item>
  )
}

export default OrderItem
